import { useCallback } from 'react';

const keyPressedStatus = { Meta: false, Control: false };

const focusSearch = menuRef => event => {
	if (event.key in keyPressedStatus) {
		keyPressedStatus[event.key] = true;
	}
	if ((keyPressedStatus.Meta || keyPressedStatus.Control) && event.key === '/') {
		menuRef.current.focus();
	}
};

const releaseKey = event => {
	if (event.key in keyPressedStatus) {
		keyPressedStatus[event.key] = false;
	}
};

let focusSearchWithRef;

let isSearchShortcutOn;

const useSearchFocusShortcut = menuRef => {
	const addSearchFocusShortcut = useCallback(() => {
		if (!isSearchShortcutOn) {
			if (!focusSearchWithRef && menuRef) {
				focusSearchWithRef = focusSearch(menuRef);
			}
			if (focusSearchWithRef) {
				document.addEventListener('keydown', focusSearchWithRef);
				document.addEventListener('keyup', releaseKey);
				isSearchShortcutOn = true;
			}
		}
	}, [menuRef]);

	const removeSearchFocusShortcut = useCallback(() => {
		if (isSearchShortcutOn && focusSearchWithRef) {
			document.removeEventListener('keydown', focusSearchWithRef);
			document.removeEventListener('keyup', releaseKey);
			isSearchShortcutOn = false;
		}
	}, []);
	return {
		addSearchFocusShortcut,
		removeSearchFocusShortcut,
	};
};

export default useSearchFocusShortcut;
